'use client';

import { c as _c } from "react/compiler-runtime";
import type { JSX, ReactNode } from 'react';
import { cn } from '@/lib/ui/utils';

/**
 * Generic dot-separated subline for search result rows.
 *
 * Each row composes its own ordered list of pieces (ticker, market title,
 * traded volume, change, etc.) and passes them in; this component renders them
 * left → right joined by `·` separators, dropping any `null`/`undefined` slots
 * so empty fields collapse cleanly.
 */
interface SearchRowSublineProps {
  pieces: ReadonlyArray<ReactNode | null | undefined>;
  className?: string;
}
export function SearchRowSubline(t0) {
  const $ = _c(10);
  const {
    pieces,
    className
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== className || $[1] !== pieces) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const visible = pieces.filter(_temp);
      if (visible.length === 0) {
        t3 = null;
        break bb0;
      }
      if ($[5] !== className) {
        t1 = cn("flex items-center gap-0.5 text-caption text-foreground-secondary min-w-0", className);
        $[5] = className;
        $[6] = t1;
      } else {
        t1 = $[6];
      }
      t2 = visible.map(_temp2);
    }
    $[0] = className;
    $[1] = pieces;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2) {
    t4 = <span className={t1}>{t2}</span>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp2(piece, i) {
  return <span key={i} className="contents">{i > 0 ? <span aria-hidden="true" className="w-2.5 text-center shrink-0 text-foreground-tertiary">·</span> : null}<span className="truncate">{piece}</span></span>;
}
function _temp(p) {
  return p !== null && p !== undefined;
}